import { ReactComponent as EditIcon } from "../../../assets/edit.svg";

type Props = {
  record: any;
  handleEdit: (record: any) => void;
};

function EditButton({ record, handleEdit }: Props) {
  return (
    <EditIcon
      className="icon"
      id={`edit-${record?.id}`}
      onClick={() => handleEdit(record)}
    />
  );
}

export default EditButton;
